// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"SupplierWiseCurrencyPurchasePage_inputContainer__B6Ng_"};